import React from 'react'
import { Modal, ErrorBoundary } from 'components'

const templates = [
  {
    title: 'Raghav Trivedi, 32',
    desc:
      "A sales exec who's planning for his daughter's education, a house purchase and a corpus for great vacations.",
    url:
      'https://plan.capitalmindwealth.com/shared/aea1aeb7-b97c-412c-9f7a-37b85fc90aac',
    cta: 'Plan for below 35',
  },
  {
    title: 'Anita Iyer, 43',
    desc:
      'VP at technology major, planning for her two kids, her retirement and to pay down that housing loan.',
    url:
      'https://plan.capitalmindwealth.com/shared/8f7a169d-fb48-4e0b-8d15-9fe81825bf8f',
    cta: 'Plan for 35-50',
  },
  {
    title: 'Sudipta Bannerjee, 54',
    desc:
      'Business head at a telco, he wants to have enough to live through retirement, and to make great experiences happen.',
    url:
      'https://plan.capitalmindwealth.com/shared/30fc44a4-8ae2-4719-876c-a2eca4f69318',
    cta: 'Plan for 50 and older',
  },
]

function Templates(props) {
  return (
    <Modal
      title="Load a Sample Plan"
      handleClose={() => props.history.goBack()}
    >
      <div className="templates">
        <ErrorBoundary>
          {templates.map(({ title, desc, url, cta }) => (
            <a href={url} key={title}>
              <h5>{title}</h5>
              <small>{cta}</small>
              <span>{desc}</span>
            </a>
          ))}
        </ErrorBoundary>
      </div>
    </Modal>
  )
}

export default Templates



// WEBPACK FOOTER //
// ./src/components/modals/Templates.js